import { render, staticRenderFns } from "./CytomineProject.vue?vue&type=template&id=27fe32d4&scoped=true"
import script from "./CytomineProject.vue?vue&type=script&lang=js"
export * from "./CytomineProject.vue?vue&type=script&lang=js"
import style0 from "./CytomineProject.vue?vue&type=style&index=0&id=27fe32d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fe32d4",
  null
  
)

export default component.exports